export const TypologiesEnum = {
    STATUS: 48,
        ACTIVE: 49,
        INACTIVE: 50,
        DELETE: 51,
        LOCKED: 300,
        IN_PROCESS_OF_AUTHORIZATION: 301,
        REJECTED: 302,
        DRAFT: 2172
}